// Meta Pixel Hook for tracking events
// Pixel ID: 1703383767307378

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

// Initialize Meta Pixel and track PageView
export function initMetaPixel() {
  if (typeof window === 'undefined') return

  // Avoid re-initialization
  if (window.fbq) {
    // If already initialized, just track PageView
    window.fbq('track', 'PageView')
    return
  }

  // Create fbq function before script loads
  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the Facebook Pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  // Insert script at the beginning of head
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }

  // Initialize pixel and track PageView immediately
  // The fbq function queues calls until the script loads
  window.fbq('init', '1703383767307378')
  window.fbq('track', 'PageView')
}

// Track PageView event (for manual calls)
export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

// Track AddToCart event
export function trackAddToCart(params?: {
  content_name?: string
  content_ids?: string[]
  content_type?: string
  value?: number
  currency?: string
}) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: params?.content_name || 'Kit Dormí de Nuevo (40+)',
      content_ids: params?.content_ids || ['42964409974993'],
      content_type: 'product',
      value: params?.value || 9300,
      currency: params?.currency || 'ARS',
    })
  }
}
